import Queue from 'app/common/lib/Queue';

export default new Queue();
